import React, { Component } from 'react';
import { Spin } from 'antd';

class LoadSpan extends Component {
    render(){
        return (
            <div>
                <Spin
                    // tip={'加载中...'}
                    style={{
                        position: 'absolute',
                        top: 160,
                        left: 200,
                        right: 0,
                        bottom: 0,
                        backgroundColor: 'rgba(255, 255, 255, .6)',
                        zIndex: 99999,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center'
                    }}
                    size={'large'}
                />
            </div>
        )
    }
}

export default LoadSpan;


// WEBPACK FOOTER //
// ./src/components/LoadSpan/index.js